export const isDebugTs = window.location.search.includes('debug') || window.location.host.includes('localhost:8030');

export const isAdsDebugTs = window.location.search.includes('debugAds=1');

export default function log(...args: any[]): void {
  if (isDebugTs) {
    console.log('%cDFP Ads', 'color: orange;', '-', ...args);
  }
}
